import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FullSenderName from '../senders/components/FullSenderName';
import { getMessageDirection } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import FullRecipientName from '../recipients/components/FullRecipientName';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallInfoHeader = ({
  message,
  recipient,
  isRecipientLoading,
  sender,
  senderName,
  isSenderLoading
}) => {
  const direction = getMessageDirection(message);
  let directionI18nKey;
  let name;
  if (direction === INCOMING) {
    directionI18nKey = 'conversations-inbox-message-history.common-message.call-header.direction.inbound';
    name = /*#__PURE__*/_jsx(FullSenderName, {
      sender: sender,
      senderName: senderName,
      isLoading: isSenderLoading
    });
  } else {
    directionI18nKey = 'conversations-inbox-message-history.common-message.call-header.direction.outbound';
    name = /*#__PURE__*/_jsx(FullRecipientName, {
      recipient: recipient,
      isLoading: isRecipientLoading
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage
  // eslint-disable-next-line conversations/no-dynamic-i18n
  , {
    message: directionI18nKey,
    options: {
      name
    }
  });
};
CallInfoHeader.displayName = 'CallInfoHeader';